// extracted by mini-css-extract-plugin
module.exports = {"propertyListItem":"PropertyListItem_propertyListItem__Ddte_","propertyListItem__product":"PropertyListItem_propertyListItem__product__Q9zHK"};